import React, { Component } from 'react';
import AccountService from '../services/AccountService';
import ProfileTopBar from './Profile/ProfileTopBar';
import ProfileViewManage from './Profile/ProfileViewManage';
import ProfileViewClientAccount from './Profile/ProfileViewClientAccount';
import ProfileBottomBar from './Profile/ProfileBottomBar';
import LocalDataManager from '../managers/LocalDataManager';

const profileLinks = [{
    label: 'User Info',
    icon: 'person',
    index: 0
}, {
    label: 'Accounts',
    icon: 'store_mall_directory',
    index: 1
}
];

export default class ProfilePage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: "Profile",
            activeIndex: 0,
            mode: "view",
            isScrollTop: true,
            profileData: {
                useZeeZorAccount: true, //was false
                googleId: null,
                facebookId: null,
                instagramId: null,
                avatarType: null,
                avatarUrl: null,
                imageData: null
            },
            isLoading: true,
            allClientAccounts: [],
            clientAccountMap: {}
        };
        this.scrollTop = 0;

        this.dbm = new LocalDataManager();
        this.accountService = new AccountService();

        this.state.settings = this.dbm.getSettingsInfo();

        this.init = this.init.bind(this);
        this.handleScrollTop = this.handleScrollTop.bind(this);
        this.handleNavChange = this.handleNavChange.bind(this);
        this.handleModeChange = this.handleModeChange.bind(this);
        this.handleSelectClientAccountAdmin = this.handleSelectClientAccountAdmin.bind(this);
        this.saveProfile = this.saveProfile.bind(this);
        this.linkSocialProfile = this.linkSocialProfile.bind(this);
        this.handleNoLogerSupported = this.handleNoLogerSupported.bind(this);

        let self = this;
        self.props.superInit(self.init, undefined, undefined, undefined);

        // if (window.localStorage["isAuthed"] != 'true') {
        //     this.props.logout();
        // } else {
        //     this.accountService.ping(() => {
        //         self.init();
        //     }, () => {
        //         self.props.logout();
        //     });
        // }
    }

    componentDidMount() {
        this.props.loadingOn();
    }

    componentWillReceiveProps() {

    }

    init() {
        let self = this;
        self.dbm.getAccountInfo().then((profileDataExist) => {

            self.accountService.getUserInfo(profileDataExist.userId, (profileData) => {

                self.dbm.saveAccountInfo(profileData);

                if (profileData.avatarType == null) {
                    profileData.avatarType = "Insights";
                }

                self.accountService.getClientAccountAndLocations((res) => {

                    let clientAccountMap = res.clientAccounts.reduce((r, e) => {
                        let key = e.name;
                        if (!r[key]) {
                            r[key] = {
                                clientAccountId: e.clientAccountId,
                                locations: e.locations,
                                name: e.name
                            };
                        }
                        return r;
                    }, {});

                    self.setState({ profileData: profileData, allClientAccounts: res.clientAccounts, clientAccountMap: clientAccountMap, isLoading: false }, () => {
                        self.props.loadingOff();
                        let welcomeSeen = window.localStorage.getItem("zzCAWelcomeSeen");
                        if ((profileDataExist.clientAccountList.length === 0 || (
                            profileDataExist.clientAccountList.length === 1 && profileDataExist.clientAccountList.clientAccountId === "8cc35cfd-352e-4900-825e-8671e330c5da")) &&
                            (welcomeSeen === undefined || welcomeSeen === null || welcomeSeen.toString() === 'false')) {
                            alert("Welcome to Mindbody Insights! To get started, click the \"Accounts\" tab and select your business.");
                            window.localStorage.setItem('zzCAWelcomeSeen', true);
                        }
                    });
                }, (err) => {

                    self.props.loadingOff();
                })

            }, (err) => {

                self.props.loadingOff();
            });
        });
    }

    handleScrollTop(isScrollTop, scrollTop) {
        if (this.state.isScrollTop != isScrollTop) {
            this.scrollTop = scrollTop;
            this.setState({ isScrollTop: isScrollTop });
        }
    }

    scrollToTop(activeTabIndex, tabId, tabPanelId) {
        // Mobile devices use an emulator and the scrolling is attached to the entire dialog
        // instead of the tabs-container.
        const emulator = document.getElementById('settings-page-outer');
        if (emulator) {
            emulator.scrollTop = 0;
            return;
        }

        const panel = document.getElementById(tabPanelId);
        if (panel) {
            panel.parentNode.scrollTop = 0;
        }
    }

    handleNavChange(index) {
        $('.profile-central-outer').animate({ scrollTop: 0 }, 400);
        this.setState({ activeIndex: index, mode: 'view' });
    }

    handleModeChange(mode) {
        $('.profile-central-outer').animate({ scrollTop: 0 }, 400);
        this.setState({ mode: mode });
    }

    handleSelectClientAccountAdmin(index) {
        zzDataCache.blastLocation = [];
        zzDataCache.blastEmployee = [];
        zzDataCache.blastEmployeeOverwrite = [];
        this.setState({ settings: this.dbm.saveSetting('selectedClientAccountIndex', index) });
        this.props.onClientAccountSelect();
    }

    saveProfile(inputVals, selectedAvatar, imageDataOrURL, tempImage) {
        let self = this;
        this.props.loadingOn();

        let profile = this.state.profileData;
        profile.firstName = inputVals.firstName;
        profile.lastName = inputVals.lastName;
        profile.nickName = inputVals.nickName;
        profile.email = inputVals.email;
        profile.phoneNumber = inputVals.phoneNumber;
        profile.avatarType = selectedAvatar;
        profile.avatarUrl = imageDataOrURL;
        profile.avatarImage = tempImage;

        this.setState({ profileData: profile }, () => {
            self.accountService.saveUserProfile(profile, (result) => {
                self.dbm.saveAccountInfo(result).then(() => {
                    self.props.updateAccountInfo();
                    alert("Profile Saved");
                    self.props.loadingOff();
                });
            }, (err) => {
                alert(err);
                self.props.loadingOff();
            });
        });
    }

    linkSocialProfile(inputVals, socialName) {
        let self = this;

        let profile = this.state.profileData;
        profile.facebookId = inputVals.facebookId;
        profile.facebookPicUrl = inputVals.facebookPicUrl;
        profile.instagramId = inputVals.instagramId;
        profile.instagramPicUrl = inputVals.instagramPicUrl;
        profile.googleId = inputVals.googleId;
        profile.googlePicUrl = inputVals.googlePicUrl;

        this.setState({ profileData: profile }, () => {
            self.accountService.saveUserProfile(profile, (result) => {
                self.dbm.saveAccountInfo(result);
                self.props.loadingOff();

                if ((socialName === 'Facebook' && profile.facebookId === null) || (socialName === 'Instagram' && profile.instagramId === null) ||
                    (socialName === 'Google' && profile.googleId === null)) {
                    alert(socialName + " Account Unlinked");
                } else {
                    alert(socialName + " Account Linked");
                }

            }, (err) => { });
        });
    }

    handleNoLogerSupported() {
        alert("Social media accounts are no longer supported.");
        return;
    }

    render() {

        let outerStyles = [];
        for (var i = 0; i < profileLinks.length; i++) {
            if (profileLinks[i].index === this.state.activeIndex) {
                outerStyles.push({ left: '0' });
            } else if (profileLinks[i].index < this.state.activeIndex) {
                outerStyles.push({ left: '-100vw' });
            }
            else if (profileLinks[i].index > this.state.activeIndex) {
                outerStyles.push({ left: '100vw' });
            }
        }



        return (
            <div id="page-outer" className="profile-page-outer">
                <ProfileTopBar
                    toggleNav={this.props.toggleNav}
                    isScrollTop={this.state.isScrollTop}
                    handleModeChange={this.handleModeChange}
                    mode={this.state.mode}
                />

                {
                    !this.state.isLoading ?
                        (<ProfileViewManage
                            style={outerStyles[0]}
                            mode={this.state.mode}
                            saveProfile={this.saveProfile}
                            linkSocialProfile={this.handleNoLogerSupported}
                            profileData={this.state.profileData}
                            handleScrollTop={this.handleScrollTop}
                            loadingOn={this.props.loadingOn}
                            loadingOff={this.props.loadingOff}
                        />)
                        : null
                }
                {
                    !this.state.isLoading ?
                        (<ProfileViewClientAccount
                            style={outerStyles[1]}
                            mode={this.state.mode}
                            profileData={this.state.profileData}
                            allClientAccounts={this.state.allClientAccounts}
                            clientAccountMap={this.state.clientAccountMap}
                            handleModeChange={this.handleModeChange}
                            handleScrollTop={this.handleScrollTop}
                            loadingOn={this.props.loadingOn}
                            loadingOff={this.props.loadingOff}
                            handleSelectClientAccountAdmin={this.handleSelectClientAccountAdmin}
                        />)
                        : null
                }
                <ProfileBottomBar activeIndex={this.state.activeIndex} links={profileLinks} handleNavChange={this.handleNavChange} />
            </div>
        );
    }
}